import requestClient from "../api/requestClient";
import { BASE_API } from "../constants";
import { getActiveBusinessId } from "../queries";

export type SurrealAuthToken =
  | string
  | {
      username: string;
      password: string;
      namespace?: undefined;
      database?: undefined;
      scope?: undefined;
    }
  | null
  | undefined;

export type SurrealAuthTokenResponse = {
  data: {
    token?: SurrealAuthToken;
  };
};

// Fetch authentication token
export const fetchSurrealAuthToken = async () => {
  return (await requestClient.get(
    `${BASE_API}/api/auth/token/surreal/?business_id=${getActiveBusinessId()}`
  )) as Promise<SurrealAuthTokenResponse>;
};
